import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import _ from 'lodash';
const getColumnParam = (index) => `col${index}`;
const getOperatorParam = (index) => `op${index}`;
const getValueParam = (index) => `val${index}`;
const MAX_RUNTIME_FILTERS = 50;
export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["Eq"] = "EQ";
    FilterTypes["Ne"] = "NE";
    FilterTypes["Lt"] = "LT";
    FilterTypes["Le"] = "LE";
    FilterTypes["Gt"] = "GT";
    FilterTypes["Ge"] = "GE";
    FilterTypes["In"] = "IN";
    FilterTypes["Bw"] = "BW";
    FilterTypes["Contains"] = "CONTAINS";
    FilterTypes["BeginsWith"] = "BEGINS_WITH";
    FilterTypes["EndsWith"] = "ENDS_WITH";
    FilterTypes["BwInc"] = "BW_INC";
    FilterTypes["BwIncMin"] = "BW_INC_MIN";
    FilterTypes["BwIncMax"] = "BW_INC_MAX";
    FilterTypes["Like"] = "LIKE";
})(FilterTypes || (FilterTypes = {}));
const FILTER_OPERATORS = {
    EQ: FilterTypes.Eq,
    NE: FilterTypes.Ne,
    LT: FilterTypes.Lt,
    LE: FilterTypes.Le,
    GT: FilterTypes.Gt,
    GE: FilterTypes.Ge,
    CONTAINS: FilterTypes.Contains,
    BEGINS_WITH: FilterTypes.BeginsWith,
    ENDS_WITH: FilterTypes.EndsWith,
    BW_INC_MAX: FilterTypes.BwIncMax,
    BW_INC_MIN: FilterTypes.BwIncMin,
    BW_INC: FilterTypes.BwInc,
    BW: FilterTypes.Bw,
    IN: FilterTypes.In,
};
export function getRuntimeFilterInput(queryParams) {
    const START_INDEX = 1;
    const result = [];
    for (let index = START_INDEX; index < MAX_RUNTIME_FILTERS; index++) {
        if (_.get(queryParams, getColumnParam(index))) {
            const operatorParam = _.get(queryParams, getOperatorParam(index));
            const filterType = FILTER_OPERATORS[_.toUpper(operatorParam)];
            let filterValue = _.get(queryParams, getValueParam(index));
            if (_.isArray(filterValue)) {
                filterValue = filterValue.map((val) => _.toString(val));
            }
            else {
                filterValue = _.toString(filterValue);
            }
            if (!_.isNil(filterType))
                result.push({
                    columnName: _.get(queryParams, getColumnParam(index)),
                    filterType,
                    value: filterValue,
                });
        }
        else {
            break;
        }
    }
    return result;
}
export function getRuntimeFilter(defaultQueryParams) {
    const urlSearchParams = _.mapValues(getQueryParamsAndQueryString({ includeSearch: true, includeHash: true })
        .queryParamsMultiValue, val => (val.length === 1 ? val[0] : val));
    const result = getRuntimeFilterInput(urlSearchParams);
    if (defaultQueryParams) {
        const resultDefault = getRuntimeFilterInput(_.mapValues(defaultQueryParams, val => val.length === 1 ? val[0] : val));
        resultDefault.forEach(filter => {
            const matchingFilter = result.find(item => item.columnName === filter.columnName &&
                item.filterType === filter.filterType);
            if (matchingFilter) {
                matchingFilter.value = filter.value;
            }
            else {
                result.push(filter);
            }
        });
    }
    return result;
}
//# sourceMappingURL=runtime-filters.util.js.map